module.exports = __webpack_public_path__ + "media/src/assets/images/area-info2-01b4631aa8423904312e5d0adb025690.png";